import Buy from './views/Buy.vue';
import Plans from './views/Plans.vue';
import PlanDetail from './views/PlanDetail.vue';
import AddPaymentMethod from './views/AddPaymentMethod.vue';
import Recharge from './views/Recharge.vue';

const routes = [
  {
    path: '/plan/subscribe/:id',
    name: 'Plan-Subscribe',
    component: Buy,
  },
  {
    path: '/plan/list',
    name: 'Plans',
    component: Plans,
  },
  {
    path: '/plan/detail',
    name: 'PlanDetail',
    component: PlanDetail,
  },
  {
    path: '/payment/method',
    name: 'AddPaymentMethod',
    component: AddPaymentMethod,
  },
  {
    path: '/plan/recharge',
    name: 'Recharge',
    component: Recharge,
  },
];

export default routes;
